import { IColumn } from '@fluentui/react';
import { IH2OTheme, IItemStyles, Item } from '@h2oai/ui-kit';

import { tagStyle } from '../../common/common.styles';
import { EScorerErrorColumns, EScorerErrorEntry, EScorerLatencyColumns, EScorerLatencyEntry } from './EScorer.utils';

export const eScorerLatencyColumns: IColumn[] = [
  {
    key: EScorerLatencyColumns.Date,
    fieldName: EScorerLatencyColumns.Date,
    name: 'Date',
    minWidth: 200,
    maxWidth: 200,
  },
  {
    key: EScorerLatencyColumns.ModelName,
    fieldName: EScorerLatencyColumns.ModelName,
    name: 'Model Name',
    minWidth: 350,
  },
  {
    key: EScorerLatencyColumns.ScoreMode,
    fieldName: EScorerLatencyColumns.ScoreMode,
    name: 'Score Mode',
    minWidth: 200,
    onRender: (item: EScorerLatencyEntry) => {
      const scoreMode = (item.scoreMode as 'REAL_TIME') || 'BATCH';
      const scoreModeOptions: Record<string, { style: (theme: IH2OTheme) => Partial<IItemStyles>; label: string }> = {
        REAL_TIME: { style: realtimeStyles, label: 'Real Time' },
        BATCH: { style: batchStyles, label: 'Batch' },
      };
      return (
        <div>
          <Item
            data={{
              id: '',
              title: scoreModeOptions[scoreMode].label,
            }}
            styles={scoreModeOptions[scoreMode].style || {}}
            idField="id"
            labelField="title"
          />
        </div>
      );
    },
  },
  {
    key: EScorerLatencyColumns.DataPointsCount,
    fieldName: EScorerLatencyColumns.DataPointsCount,
    name: 'Datapoints',
    minWidth: 200,
  },
  {
    key: EScorerLatencyColumns.AvgLatency,
    fieldName: EScorerLatencyColumns.AvgLatency,
    name: 'Average Latency',
    minWidth: 200,
  },
];

export const eScorerErrorColumns: IColumn[] = [
  {
    key: EScorerErrorColumns.Date,
    fieldName: EScorerErrorColumns.Date,
    name: 'Date',
    minWidth: 200,
    maxWidth: 200,
  },
  {
    key: EScorerErrorColumns.ModelName,
    fieldName: EScorerErrorColumns.ModelName,
    name: 'Model Name',
    minWidth: 350,
  },
  {
    key: EScorerErrorColumns.ScoreMode,
    fieldName: EScorerErrorColumns.ScoreMode,
    name: 'Score Mode',
    minWidth: 200,
    onRender: (item: EScorerErrorEntry) => {
      const scoreMode = (item.scoreMode as 'REAL_TIME') || 'BATCH';
      const scoreModeOptions: Record<string, { style: (theme: IH2OTheme) => Partial<IItemStyles>; label: string }> = {
        REAL_TIME: { style: realtimeStyles, label: 'Real Time' },
        BATCH: { style: batchStyles, label: 'Batch' },
      };
      return (
        <div>
          <Item
            data={{
              id: '',
              title: scoreModeOptions[scoreMode].label,
            }}
            styles={scoreModeOptions[scoreMode].style || {}}
            idField="id"
            labelField="title"
          />
        </div>
      );
    },
  },
  {
    key: EScorerErrorColumns.TotalErrors,
    fieldName: EScorerErrorColumns.TotalErrors,
    name: 'Total Errors',
    minWidth: 200,
  },
  {
    key: EScorerErrorColumns.LastErrorMsg,
    fieldName: EScorerErrorColumns.LastErrorMsg,
    name: 'Last Error Message',
    minWidth: 200,
    onRender: (item: EScorerErrorEntry) => {
      return (
        <div
          style={{
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
          }}
        >
          {item.lastErrorMsg}
        </div>
      );
    },
  },
];

export const realtimeStyles = (theme: IH2OTheme): Partial<IItemStyles> => ({
  root: {
    ...tagStyle(theme),
    backgroundColor: theme.palette?.blue100,
    color: theme.semanticColors?.categoryText,
  },
});

export const batchStyles = (theme: IH2OTheme): Partial<IItemStyles> => ({
  root: {
    ...tagStyle(theme),
    backgroundColor: theme.palette?.yellow200,
    color: theme.semanticColors?.categoryText,
  },
});
